"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LineThicknessThin = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LineThicknessThin_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 5,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.611 3.007a8.314 8.314 0 0 0-1.291.877C7.586 4.496 7 5.241 7 6c0 .247.05.383.096.459a.44.44 0 0 0 .221.173c.263.11.65.118 1.183.118h.052c.46 0 1.046 0 1.515.195.264.11.511.288.686.568.171.276.247.61.247.987 0 .65-.317 1.315-.709 1.902-.4.601-.926 1.19-1.437 1.702A21.402 21.402 0 0 1 6.98 13.76l-.18.14a.5.5 0 0 1-.601-.8l.163-.126a20.411 20.411 0 0 0 1.783-1.578c.489-.488.964-1.024 1.313-1.548C9.817 9.31 10 8.85 10 8.5c0-.247-.05-.383-.096-.459a.44.44 0 0 0-.221-.173c-.263-.11-.65-.118-1.183-.118h-.052c-.46 0-1.046 0-1.515-.195a1.437 1.437 0 0 1-.686-.568C6.076 6.71 6 6.377 6 6c0-1.24.914-2.246 1.68-2.884A9.312 9.312 0 0 1 9.13 2.13l.144-.076.001-.001a.5.5 0 0 1 .448.894l-.113.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LineThicknessThin_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LineThicknessThin;
exports["default"] = _default;